import { usePage } from '@inertiajs/react';

export function useIsPreviewMode(): boolean {
  const { props } = usePage<{ previewMode?: boolean }>();
  return props.previewMode === true;
}
